<template>
  <div class="d-flex align-items-center">
    <div>
      <small>
        {{ $t('pagination.showing') }}
        {{ from }}
        {{ $t('pagination.to') }}
        {{ to }}
        {{ $t('pagination.of') }}
        {{ totalData }}
        {{ $t('pagination.entries') }}
      </small>
    </div>
    <div class="ml-auto">
      <div class="pagination font-weight-bold">
        <a
          :class="{ 'active-color': showColor('prev') }"
          class="arrow-css"
          @click="pageNavigation('prev')"
        ><i
          class="fa fa-chevron-left"
          aria-hidden="true"
        /></a>
        <span
          v-for="(page, i) in totalPage"
          :key="i"
        >
          <template v-if="((i+1) >= currentPage)">
            <template v-if="(i < currentPage+3)">
              <a
                :class="{ 'active-color': currentPage === (i+1) }"
                @click="clickPage(i+1)"
              >
                {{ i + 1 }}
              </a>
            </template>
          </template>
        </span>
        <a
          :class="{ 'active-color': showColor('next') }"
          class="arrow-css"
          @click="pageNavigation('next')"
        ><i
          class="fa fa-chevron-right"
          aria-hidden="true"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationApi',

  props: {
    pageCount: {
      type: Number,
      required: true
    },
    fetchItem: {
      type: Function,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    nextPage: {
      type: Number,
      required: true
    },
    prevPage: {
      type: Number,
      required: true
    },
    totalPage: {
      type: Number,
      required: true
    },
    totalData: {
      type: Number,
      default: 0
    },
    visibleItem: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      pageSum: 0
    }
  },

  computed: {
    from () {
      return 1 + (this.currentPage - 1) * this.perPage
    },
    to () {
      return this.from - 1 + this.visibleItem
    }
  },

  methods: {
    pageNavigation (navigate) {
      if (this.nextPage !== 0 || this.prevPage !== 0) {
        switch (navigate) {
          case 'next':
            if (this.nextPage <= this.totalPage) {
              this.fetchItem(this.nextPage, this.perPage)
            }
            break
          case 'prev':
            this.fetchItem(this.prevPage, this.perPage)
            break
        }
      }
    },
    clickPage (page) {
      this.fetchItem(page, this.perPage)
    },
    showColor (choose) {
      switch (choose) {
        case 'next':
          return this.nextPage <= this.totalPage
        case 'prev':
          return this.prevPage !== 0
      }
    }
  }
}
</script>

<style scoped>
.pagination {
  background-color: white;
}
.pagination a {
  cursor: pointer;
  color: #aaaaaa;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border-radius: 8px;
  margin: 5px;
  font-size: 15px;
}
.active-color {
  background-color: #18b2bd !important;
  color: white !important;
}
.arrow-css {
  background-color: #DEDEDE;
}
</style>
